import React from 'react';
import './TableShimmer.scss';

export type TableShimmerProps = {
  rows?: number;
  columns?: number;
};

const TableShimmer: React.FC<TableShimmerProps> = ({ 
  rows = 5, 
  columns = 4 
}) => {
  return (
    <div className="table-shimmer">
      <div className="table-shimmer__title-section">
        <div className="table-shimmer__title shimmer-line"></div>
        <div className="table-shimmer__subtitle shimmer-line"></div>
      </div>
      
      <div className="table-shimmer__wrapper">
        <table className="table-shimmer__table">
          <thead className="table-shimmer__thead">
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th key={`header-${index}`} className="table-shimmer__header-cell">
                  <div className="shimmer-line"></div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="table-shimmer__tbody">
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={`row-${rowIndex}`} className="table-shimmer__row">
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={`cell-${rowIndex}-${colIndex}`} className="table-shimmer__cell">
                    <div className="shimmer-line"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableShimmer;
